import styled from "styled-components"

export const AboutHeader = styled.div `
    display: flex;
    justify-content: space-evenly;
    align-content: center;
`

export const AboutTitle = styled.div`
    font-family: lyon-display-web;
    font-size: 55px;
    font-weight: 800;
`

export const AboutBody = styled.div`
    display: flex;
    justify-content: space-evenly;
    padding-top: 40px;
`

